var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2821 14.0869C31.1721 14.0869 34.3256 10.9335 34.3256 7.04347C34.3256 3.15347 31.1721 0 27.2821 0C23.3921 0 20.2386 3.15347 20.2386 7.04347C20.2386 10.9335 23.3921 14.0869 27.2821 14.0869Z",
    fill: "#252D43"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2821 34.3262C31.1721 34.3262 34.3256 31.1727 34.3256 27.2827C34.3256 23.3927 31.1721 20.2393 27.2821 20.2393C23.3921 20.2393 20.2386 23.3927 20.2386 27.2827C20.2386 31.1727 23.3921 34.3262 27.2821 34.3262Z",
    fill: "url(#paint0_linear_352_52205)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2821 54.5645C31.1721 54.5645 34.3256 51.411 34.3256 47.521C34.3256 43.631 31.1721 40.4775 27.2821 40.4775C23.3921 40.4775 20.2386 43.631 20.2386 47.521C20.2386 51.411 23.3921 54.5645 27.2821 54.5645Z",
    fill: "#252D43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04347 0C3.15328 0 0 3.15328 0 7.04347V47.5212C0 51.411 3.15328 54.5647 7.04347 54.5647C10.9337 54.5647 14.0869 51.4114 14.0869 47.5212V7.04347C14.0869 3.15328 10.9333 0 7.04347 0Z",
    fill: "url(#paint1_linear_352_52205)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5212 0C43.6314 0 40.4777 3.15328 40.4777 7.04347V47.5212C40.4777 51.411 43.631 54.5647 47.5212 54.5647C51.4114 54.5647 54.5647 51.4114 54.5647 47.5212V7.04347C54.5647 3.15328 51.411 0 47.5212 0Z",
    fill: "url(#paint2_linear_352_52205)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_352_52205",
    x1: 27.2823,
    y1: 50.7588,
    x2: 27.2823,
    y2: 0.619992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1617,
    stopColor: "#FA607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_352_52205",
    x1: 7.04339,
    y1: 51.072,
    x2: 7.04339,
    y2: -12.0584,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1617,
    stopColor: "#FA607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7902,
    stopColor: "#FB8095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_352_52205",
    x1: 47.5212,
    y1: 51.072,
    x2: 47.5212,
    y2: -11.4577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1617,
    stopColor: "#FA607B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7978,
    stopColor: "#FB8095"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.66bcd4e7e21e5e1e004587ff3d561442.svg";
export { ForwardRef as ReactComponent };